import { lazy } from 'react';
import type { ViewRegistry } from '@/app/routing/view-registry';
import { useNavigation } from '@/app/navigation/use-navigation';

const PDFTemplateManager = lazy(() => import('@/pages/PDFTemplateManager'));
const PDFLayoutBuilder = lazy(() => import('@/pages/PDFLayoutBuilder'));

function PDFTemplateManagerView() {
  return <PDFTemplateManager />;
}

function PDFLayoutBuilderView() {
  const { actions } = useNavigation();
  return <PDFLayoutBuilder onBack={actions.goBack} />;
}

export const pdfViews: Partial<ViewRegistry> = {
  'pdf-template-manager': {
    component: PDFTemplateManagerView,
    guard: { screen: 'pdf-template-manager' },
  },
  'pdf-layout-builder': {
    component: PDFLayoutBuilderView,
    guard: { screen: 'pdf-layout-builder' },
  },
};
